import React from 'react';
import { BaseModal } from '../BaseModal';
import type { Product } from '../../pages/CatalogPage';
import type { Country } from '../../types';

type DeviceDetailModalProps = {
  device: Product;
  onClose: () => void;
  visibleCountries: Country[];
};

export function DeviceDetailModal({
  device,
  onClose,
  visibleCountries,
}: DeviceDetailModalProps) {
  return (
    <BaseModal
      isOpen={true}
      onClose={onClose}
      title={device.solution}
      subtitle="Hardware Details"
      maxWidth="5xl"
    >
      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-foreground mb-1">Platform</h3>
          <p className="text-sm text-muted-foreground">{device.platform}</p>
        </div>

        {device.solution_description && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Description</h3>
            <p className="text-sm text-muted-foreground">{device.solution_description}</p>
          </div>
        )}

        {device.hardware_family && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Hardware Family</h3>
            <p className="text-sm text-muted-foreground">{device.hardware_family}</p>
          </div>
        )}

        {device.model && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Model</h3>
            <p className="text-sm text-muted-foreground">{device.model}</p>
          </div>
        )}

        {device.tag && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Tag</h3>
            <p className="text-sm text-muted-foreground">{device.tag}</p>
          </div>
        )}

        {device.vertical && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Vertical</h3>
            <p className="text-sm text-muted-foreground">{device.vertical}</p>
          </div>
        )}

        {device.development && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Development Status</h3>
            <p className="text-sm text-muted-foreground">{device.development}</p>
          </div>
        )}

        {device.countries && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">Country Availability</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {visibleCountries.map(country => {
                const availability = device.countries[country.code];
                return (
                  <div key={country.code} className="flex items-center gap-2 text-sm">
                    <span className="text-base">{country.flag}</span>
                    <span className="text-muted-foreground">{country.code}</span>
                    <span>
                      {availability === true ? (
                        <span className="text-green-600 font-semibold">✓</span>
                      ) : availability === 'Coming Soon' ? (
                        <span className="text-yellow-600 text-xs italic">Soon</span>
                      ) : (
                        <span className="text-red-500 font-semibold">✗</span>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {device.notes && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Additional Notes</h3>
            <p className="text-sm text-muted-foreground whitespace-pre-wrap">{device.notes}</p>
          </div>
        )}
      </div>
    </BaseModal>
  );
};
